import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { Button, Card, PageHeader } from "@cofano/cck";
import { Language, usePermission } from "imports/Utils";
import ProductsTable from "view/products/components/table/ProductsTable";
import { CompareDangerousGoodsDocument } from "__generated__/view/products/graphql/product.mutations.generated";

const Products = () => {

	const navigate = useNavigate();

	const { isCofanoAdmin, isReadOnly } = usePermission();

	const [ refetchKey, setRefetchKey ] = useState(0);

	const [ compareAdnGoods ] = useMutation(CompareDangerousGoodsDocument, {
		onCompleted: () => setRefetchKey(prev => prev + 1),
	});

	return (
		<div>
			<PageHeader>
				<PageHeader.Title>
					{Language("PRODUCT")}
				</PageHeader.Title>

				<PageHeader.Actions>
					{isCofanoAdmin && (
						<Button
							onClick={() => compareAdnGoods()}
							variant="outlined">
							{Language("PRODUCTS_TRIGGER_COMPARISON")}
						</Button>
					)}

					{!isReadOnly && (
						<Button
							onClick={() => navigate("/view/products/create")}>
							{Language("ADD_BUTTON")}
						</Button>
					)}
				</PageHeader.Actions>
			</PageHeader>

			<Card disablePadding>
				<ProductsTable refetchKey={refetchKey} />
			</Card>
		</div>
	);
};

export default Products;
